import _ from 'lodash';
import {mapActions} from 'vuex';

import {
  notificationColors,
  notificationContext,
  notificationStatus,
  notificationType
} from '@/modules/neodash/enuns/notification.enum';
import {i18nMixin} from './i18n.mixin';

import {NOTIFICATIONS_SEND, NOTIFICATIONS_SEND_TOAST} from '@/store/modules/notifications/types';

export const notificationMixin = {
  mixins: [i18nMixin],

  methods: {
    ...mapActions({
      sendNotification: NOTIFICATIONS_SEND,
      sendToast: NOTIFICATIONS_SEND_TOAST
    }),

    sendAlert(message) {
      const msg = {
        id: _.random(99999, 99999999),
        type: this.getNotificationColor(message.status),
        status: message.status,
        icon: '',
        title: this.i18n.i18n(`Upload.${_.capitalize(this.getNotificationStatus(message.status))}`),
        message: this.i18n.i18n(`Upload.Messages.${_.capitalize(this.getNotificationStatus(message.status))}`, message.data),
        data: message.data
      };

      if (message.status === notificationStatus.error) {
        this.sendNotification(msg);
      } else {
        this.sendToast(msg);
      }
    },

    getNotificationContext(context) {
      return notificationContext[context];
    },

    getNotificationType(type) {
      return notificationType[type];
    },

    getNotificationStatus(status) {
      return notificationStatus[status];
    },

    getNotificationIcon(status) {
      switch (status) {
        case notificationType.error:
          return 'bug red';
        case notificationType.success:
          return 'check circle green';
        case notificationType.alert:
          return 'warning sign orange';
        default:
          return 'announcement blue';
      }
    },

    getNotificationColor(status) {
      return notificationColors[status];
    }
  }
};
